import { SnapsnapGatewayBase } from './base'
import { ICredit } from '@/types/domain/credit'
import * as request from '@/infra/network/Snapsnap/requests/credit'
import { mapBrandFromApi } from '@/utils/creditBrand'
import { Snapsnap } from '@photocreate/snapsnap-api'

export default class Credit extends SnapsnapGatewayBase {
  async getCreditCardInfo(): Promise<ICredit> {
    const response: Snapsnap.Credit.GetCreditCardInfoResponse = await this.apiClient.request(new request.GetCreditCardInfo())
    const { card_exp_month, card_exp_year, card_number, brand } = response

    return {
      cardExpMonth: card_exp_month,
      cardExpYear: card_exp_year,
      cardNumber: card_number,
      brand: mapBrandFromApi(brand) || undefined
    }
  }

  async deleteCreditCardInfo() {
    return await this.apiClient.request(new request.DeleteCreditCardInfo())
  }

  async saveCreditCardInfo(creditToken: string, ctx?: string): Promise<{ redirectUrl: string }> {
    const { redirect_url } = await this.apiClient.request(new request.SaveCreditCardInfo(creditToken, ctx))

    return {
      redirectUrl: redirect_url
    }
  }
}
